/**
 * Zentrale Regel für Profil-Links (2026-09-03).
 *
 * Hintergrund: Namensfelder wie `authorName`, `senderName`, `userName` oder
 * `ownerName` enthalten seit den Live-Anzeigenamen den ANZEIGENAMEN
 * (z. B. "Marcel (Admin)"), nicht mehr den Benutzernamen. Ein Link, der aus
 * dem Namen gebaut wird, landet deshalb auf "Profil nicht gefunden".
 *
 * Das Backend löst `/api/player/:identifier` per Benutzername ODER User-ID
 * auf. Deshalb: Ziel immer aus `username` (wenn es wirklich der Benutzername
 * ist) oder sonst aus der User-ID bauen – nie aus einem Anzeigenamen.
 */
export interface ProfilePathInput {
  /** Echter DartCloud-Benutzername (NICHT der Anzeigename). */
  username?: string | null;
  /** User-ID (authorId, senderId, userId, ownerId …). */
  userId?: string | null;
}

const clean = (value?: string | null): string | null => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
};

/**
 * Liefert `/community/profil/<username|userId>` oder `null`, wenn weder
 * Benutzername noch ID vorhanden sind.
 */
export function profilePath(input: ProfilePathInput | null | undefined): string | null {
  if (!input) return null;
  const identifier = clean(input.username) ?? clean(input.userId);
  if (!identifier) return null;
  return `/community/profil/${encodeURIComponent(identifier)}`;
}

export default profilePath;
